// Imagens para categorias
export const CATEGORY_IMAGES: Record<string, string> = {
  'farois': 'assets/images/categories/farois.png',
  'lanternas': 'assets/images/categories/lanternas.png',
  'retrovisores': 'assets/images/categories/retrovisores.png',
  'para-choques': 'assets/images/categories/para-choque.png',
};

export function getCategoryImage(slug: string): string {
  return CATEGORY_IMAGES[slug] || 'assets/images/categories/farois.png';
}

